import { Table, type TableColumn } from "@prequel/shared-components";

type PreviewSchemaField = {
  name: string;
  prequel_type?: string;
  raw_type?: string;
  database_type_name?: string;
};

type PreviewResult = {
  schema: PreviewSchemaField[];
  records: unknown[];
};

const formatRecordValue = (record: unknown, column: string) => {
  if (!record || typeof record !== "object") {
    return "";
  }

  const value = (record as Record<string, unknown>)[column];
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value === "object") {
    return JSON.stringify(value);
  }
  return String(value);
};

const getTypeLabel = (field: PreviewSchemaField) => field.prequel_type || field.raw_type || field.database_type_name;

const PreviewTable = ({ preview }: { preview: PreviewResult }) => {
  const columns: TableColumn[] = preview.schema.map((field) => ({
    id: field.name,
    header: (
      <span className="flex min-w-0 items-center gap-1.5">
        <span className="truncate">{field.name}</span>
        {getTypeLabel(field) && (
          <code className="rounded-sm bg-gray-200 px-1.5 py-0.5 font-mono text-[11px] font-medium text-gray-700">
            {getTypeLabel(field)}
          </code>
        )}
      </span>
    ),
  }));
  const rows = preview.records.slice(0, 10).map((record, index) => ({
    id: index,
    cells: preview.schema.map((field) => ({ value: formatRecordValue(record, field.name) })),
  }));

  return <Table columns={columns} rows={rows} emptyState="No rows found." />;
};

export default PreviewTable;
